<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="name">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="inventory">
                <wbo-inventory-multi-select-search-control></wbo-inventory-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-single-select-search-control>
                    <wbo-select-options>
                        <wbo-select-option value="Pending"
                                           label="wbo.stock-transfer.option.status.pending"></wbo-select-option>
                        <wbo-select-option value="Complete"
                                           label="wbo.stock-transfer.option.status.complete"></wbo-select-option>
                        <wbo-select-option value="Processing"
                                           label="wbo.stock-transfer.option.status.processing"></wbo-select-option>
                        <wbo-select-option value="Requested"
                                           label="wbo.stock-transfer.option.status.requested"></wbo-select-option>
                        <wbo-select-option value="Dispatched"
                                           label="wbo.stock-transfer.option.status.dispatched"></wbo-select-option>
                        <wbo-select-option value="Rejected"
                                           label="wbo.stock-transfer.option.status.rejected"></wbo-select-option>
                        <wbo-select-option value="Cancelled"
                                           label="wbo.stock-transfer.option.status.cancelled"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'dateFrom'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'dateTo'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-column field="name"></wbo-column>
        <wbo-date-column field="created"></wbo-date-column>
        <wbo-column field="status"></wbo-column>
        <wbo-column field="employee"></wbo-column>
        <wbo-column field="value"></wbo-column>
        <wbo-actions-search-column>
            <wbo-report-search-action [idColumn]="'transferId'"></wbo-report-search-action>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
